import { createBrowserHistory } from 'history';
import { createPreserveQueryHistory } from '@publicisgroupe/p-os-components';
import { Router, Route, Switch } from 'react-router-dom';
import { staticFilters } from 'utils/helpers';
import { ROUTE_LOGIN, ROUTE_ROOT } from 'utils/routes';
import PrivateApp from 'components/PrivateApp';
import Login from 'components/Login';

export const ModuleRouter = () => {
  return (
    <Router history={createPreserveQueryHistory(createBrowserHistory, staticFilters)()}>
      <Switch>
        <Route exact path={ROUTE_LOGIN} component={Login} />
        <Route path={ROUTE_ROOT} component={PrivateApp} />
      </Switch>
    </Router>
  );
};
